import SodRemediateModal from './SodRemediateModal';

export default SodRemediateModal;
